<template>
  <async-btn
    :task="task"
    :disabled="!canExport"
    v-bind="$attrs"
    @click="exportToReport"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { Report } from '@/type';
import AsyncBtn from '@/components/AsyncBtn.vue';
import notify from '@/components/notify';
import { exportToReport } from '.';

interface Data {
  task: Promise<Report>|null
}

export default defineComponent({
  emits: ['exported'],
  components: {
    AsyncBtn,
  },
  props: {
    postSearchId: {
      type: Number,
      required: true,
    },
    reportName: {
      type: String,
      required: true,
    },
  },
  data(): Data {
    return {
      task: null,
    };
  },
  computed: {
    canExport(): boolean {
      return (this.reportName !== '');
    },
  },
  methods: {
    exportToReport() {
      if (this.reportName === '') return;
      this.task = exportToReport(this.postSearchId, this.reportName);
      this.task.then((report) => {
        this.$emit('exported', report);
        notify('Search has been exported to a report.');
      });
    },
  },
});
</script>
